<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconShare_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M4.8 3A4.8 4.8 0 0 0 0 7.8v8.4A4.8 4.8 0 0 0 4.8 21h6.12v-8.883l-3.906 2.287c-.306.182-.682.072-.882-.258a.94.94 0 0 1 .074-1.068l5.297-6.245c.263-.31.73-.31.993 0l5.298 6.245a.94.94 0 0 1 .074 1.068c-.198.326-.572.44-.882.258l-3.906-2.287V21h6.12a4.8 4.8 0 0 0 4.8-4.8V7.8A4.8 4.8 0 0 0 19.2 3z"
    />
</svg>
